/* REFORMED — product.js
   PDP: variant selection (swatches + size buttons), price/availability/
   low-stock updates, gallery thumb swap, quantity stepper (brief §5).
   The selected variant id is written into the product form; cart.js
   intercepts the submit -> AJAX add -> drawer opens. */

(function () {
  'use strict';

  var root = document.querySelector('[data-product]');
  if (!root) return;

  var dataEl = document.querySelector('[data-product-json]');
  if (!dataEl) return;
  var data = JSON.parse(dataEl.textContent);
  var variants = data.variants;
  var mediaMap = data.mediaMap || {};
  var inventory = data.inventory || {};

  var moneyFormat = (window.theme && window.theme.moneyFormat) || '${{amount}}';
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
      .replace(/\{\{\s*amount(_with_comma_separator)?\s*\}\}/, whole + '.' + parts[1]);
  }

  /* ---------- state ---------- */

  var optionGroups = Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));
  var selected = optionGroups.map(function (group) {
    var active = group.querySelector('.active[data-option-value]');
    return active ? active.dataset.optionValue : null;
  });

  function findVariant(opts) {
    return variants.find(function (v) {
      return v.options.every(function (value, i) { return value === opts[i]; });
    });
  }

  function variantStocked(v) {
    /* "in stock or allows overselling" */
    return v && v.available;
  }

  /* ---------- rendering ---------- */

  function updatePrice(variant) {
    var priceEl = root.querySelector('[data-price]');
    if (!priceEl || !variant) return;
    var html = '<span class="now">' + formatMoney(variant.price) + '</span>';
    if (variant.compare_at_price > variant.price) {
      html += '<span class="was">' + formatMoney(variant.compare_at_price) + '</span>';
      html += '<span class="save">Save ' + formatMoney(variant.compare_at_price - variant.price) + '</span>';
    }
    priceEl.innerHTML = html;

    var badge = root.querySelector('[data-sale-badge]');
    if (badge) {
      if (variant.compare_at_price > variant.price) {
        var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        badge.textContent = 'Save ' + pct + '%';
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    }
  }

  function updateAtc(variant) {
    var atc = root.querySelector('[data-atc]');
    if (!atc) return;
    if (!variant) {
      atc.disabled = true;
      atc.textContent = 'Unavailable';
    } else if (!variant.available) {
      atc.disabled = true;
      atc.textContent = 'Sold Out';
    } else {
      atc.disabled = false;
      atc.innerHTML = 'Add to Cart<span class="atc-price-part"> — <span data-atc-price>' + formatMoney(variant.price) + '</span></span>';
    }
  }

  function updateLowStock(variant) {
    var box = root.querySelector('[data-low-stock]');
    if (!box) return;
    var threshold = parseInt(box.dataset.threshold, 10) || 0;
    var text = box.querySelector('[data-low-stock-text]');
    var inv = variant ? inventory[variant.id] : null;
    var show = variant && threshold > 0 && variant.available &&
      inv && inv.managed && inv.qty > 0 && inv.qty <= threshold;
    box.hidden = !show;
    if (show && text) text.textContent = 'Only ' + inv.qty + ' left in ' + variant.title;
  }

  function updateGallery(variant) {
    if (!variant || !mediaMap[variant.id]) return;
    var media = mediaMap[variant.id];
    setMainImage(media.src, media.srcset);
    var thumbs = root.querySelectorAll('[data-thumbs] .g-thumb');
    thumbs.forEach(function (t) {
      t.classList.toggle('active', String(t.dataset.mediaId) === String(media.id));
    });
    /* Keep the active thumb visible in the mobile horizontal strip WITHOUT
       scrolling the page. On desktop the thumbs are a static 2-row grid (no
       overflow), so the old scrollIntoView({block:'nearest'}) bubbled up to
       the window and scrolled the page down on variant click. Scroll only the
       rail, and only when it actually overflows horizontally (the mobile strip). */
    var rail = root.querySelector('[data-thumbs]');
    var activeThumb = rail && rail.querySelector('.g-thumb.active');
    if (rail && activeThumb && rail.scrollWidth > rail.clientWidth) {
      var delta = (activeThumb.getBoundingClientRect().left - rail.getBoundingClientRect().left) -
        (rail.clientWidth - activeThumb.clientWidth) / 2;
      if (rail.scrollBy) rail.scrollBy({ left: delta, behavior: 'smooth' });
      else rail.scrollLeft += delta;
    }
  }

  function setMainImage(src, srcset) {
    var main = root.querySelector('[data-main-image]');
    if (!main) return;
    main.src = src;
    if (srcset) main.srcset = srcset;
  }

  /* Mark size/swatch values that are sold out given the OTHER selections */
  function updateValueStates() {
    optionGroups.forEach(function (group, gi) {
      group.querySelectorAll('[data-option-value]').forEach(function (btn) {
        var test = selected.slice();
        test[gi] = btn.dataset.optionValue;
        var v = findVariant(test);
        var soldout = !variantStocked(v);
        btn.classList.toggle('soldout', soldout);
        btn.toggleAttribute('data-soldout', soldout);
      });
    });
  }

  function updateSticky(variant) {
    var price = document.querySelector('[data-sticky-price]');
    var btn = document.querySelector('[data-sticky-atc]');
    if (price && variant) {
      var html = '';
      if (variant.compare_at_price > variant.price) {
        html += '<span style="text-decoration:line-through">' + formatMoney(variant.compare_at_price) + '</span>';
      }
      html += '<span class="now">' + formatMoney(variant.price) + '</span>';
      price.innerHTML = html;
    }
    if (btn) {
      var ok = variant && variant.available;
      btn.disabled = !ok;
      btn.textContent = ok ? 'Add to Cart' : 'Sold Out';
    }
  }

  function applySelection() {
    var variant = findVariant(selected);
    var idInput = root.querySelector('[data-variant-id]');
    if (idInput && variant) idInput.value = variant.id;
    updatePrice(variant);
    updateAtc(variant);
    updateLowStock(variant);
    updateGallery(variant);
    updateSticky(variant);
    updateValueStates();
    if (variant) {
      var url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
  }

  /* ---------- events ---------- */

  optionGroups.forEach(function (group, gi) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-option-value]');
      if (!btn) return;
      selected[gi] = btn.dataset.optionValue;
      group.querySelectorAll('[data-option-value]').forEach(function (b) {
        var active = b === btn;
        b.classList.toggle('active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      var valueLabel = group.querySelector('[data-selected-value]');
      if (valueLabel) valueLabel.textContent = btn.dataset.optionValue;
      applySelection();
    });
  });

  /* gallery thumbs */
  var thumbsWrap = root.querySelector('[data-thumbs]');
  if (thumbsWrap) {
    thumbsWrap.addEventListener('click', function (e) {
      var thumb = e.target.closest('.g-thumb');
      if (!thumb) return;
      thumbsWrap.querySelectorAll('.g-thumb').forEach(function (t) {
        t.classList.toggle('active', t === thumb);
      });
      setMainImage(thumb.dataset.src, thumb.dataset.srcset);
    });
  }

  /* quantity stepper */
  var qty = 1;
  root.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    qty = Math.max(1, qty + parseInt(step.dataset.qtyStep, 10));
    var display = root.querySelector('[data-qty-display]');
    var input = root.querySelector('[data-qty-input]');
    if (display) display.textContent = qty;
    if (input) input.value = qty;
  });

  /* ---------- sticky ATC bar ----------
     Shows once the main ATC has scrolled up out of view (mockup parity). */
  var stickyBar = document.querySelector('[data-sticky-atc-bar]');
  var mainAtc = root.querySelector('[data-atc]');
  if (stickyBar && mainAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      stickyBar.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(mainAtc);

    stickyBar.addEventListener('click', function (e) {
      if (!e.target.closest('[data-sticky-atc]')) return;
      var form = root.querySelector('form[action*="/cart/add"]');
      if (form) {
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      }
    });
  }

  /* accordions are handled globally in global.js ([data-accordion]) */

  /* ---------- size guide modal ---------- */
  var guide = document.querySelector('[data-size-guide]');
  var guideOv = document.querySelector('[data-size-guide-overlay]');
  var guideTrigger = null;
  function setGuide(open) {
    if (!guide) return;
    if (open && document.activeElement) guideTrigger = document.activeElement;
    guide.classList.toggle('open', open);
    if (guideOv) guideOv.classList.toggle('open', open);
    if (open) {
      var x = guide.querySelector('[data-size-guide-close]');
      if (x) x.focus();
    } else if (guideTrigger && document.body.contains(guideTrigger)) {
      guideTrigger.focus();
      guideTrigger = null;
    }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-size-guide-open]')) setGuide(true);
    if (e.target.closest('[data-size-guide-close]')) setGuide(false);
    if (e.target.closest('[data-size-guide-overlay]')) setGuide(false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setGuide(false);
  });

  /* initial paint (also marks sold-out combos for the server-rendered state) */
  updateValueStates();
})();
